import React from 'react'
import PropTypes from 'prop-types'
import { ListGroup, ListGroupItem, ListGroupItemText } from 'reactstrap'

import './CleaningHistoryList.scss'

class CleaningHistoryList extends React.Component {
    static propTypes = {
        data: PropTypes.arrayOf(PropTypes.object)
    }

    static defaultProps = {
        data: []
    }

    render() {
        const { data } = this.props
        return (
            <ListGroup className="ao-cleaning-list">
                { data.map(item => (
                    <ListGroupItem key={ item.id } className="ao-cleaning-list__item">
                        <div className="d-flex">
                            <ListGroupItemText>{ item.entiteit }</ListGroupItemText>
                            <ListGroupItemText>{ item.actieType }</ListGroupItemText>
                            <ListGroupItemText>{ item.aantal }</ListGroupItemText>
                            <ListGroupItemText>{ new Date(Date.parse(item.datumActie)).toLocaleDateString() }</ListGroupItemText>
                            <ListGroupItemText>{ item.succes ? 'succesvol' : 'mislukt' }</ListGroupItemText>
                        </div>
                    </ListGroupItem>
                ))}
            </ListGroup>
        )
    }
}

export default CleaningHistoryList
